module.exports = __webpack_public_path__ + "static/img-subfooter-caregivers-307a2414295bd8714d780adaf37bca12.jpg";